import { useMemo } from "react";
import { LogisticPartyDetails } from "../interfaces/LogisticPartyDetails.interface";
import useDeliveryServiceProviders from "./useDeliveryServiceProviders";

/**
 * Wrapper over useDeliveryServiceProviders fn. Filters and provides the details of the required lpId.
 * @param lpId
 * @returns DeliveryServiceProviderDetails
 */
function useDeliveryServiceProviderDetails(
  dspId: string
): LogisticPartyDetails | null {
  const deliveryServiceProviders = useDeliveryServiceProviders();
  const dspDetails = useMemo(
    () =>
      deliveryServiceProviders.find(
        ({ logisticsPartyId }) => logisticsPartyId === dspId
      ),
    [deliveryServiceProviders, dspId]
  );

  return dspDetails || null;
}

export default useDeliveryServiceProviderDetails;
